import {
  pushMessageList,
  pushMessageAdd,
  pushMessageDelete
} from "@/axios/service/travel.js";
import Global from "@/utils/Global";

const MessageStore = {
  namespaced: true,
  state: {
    messageListTotal: 0,
    messageList: []
  },
  mutations: {
    messageListTotalMutation(state, value) {
      state.messageListTotal = value;
    },
    messageListMutations(state, value) {
      state.messageList = value;
    }
  },
  actions: {
    pushMessageDeleteAction(context, params) {
      let vueObj = params.vueObj;
      delete params.vueObj;
      pushMessageDelete(params).then(json => {
        if (json.respCode === 100) {
          Global.messageSuc("操作成功!");
          //查询操作
          vueObj.searchParamObj.vueObj = vueObj;
          context.dispatch("pushMessageListAction", vueObj.searchParamObj);
        } else {
        }
      });
    },
    pushMessageAddAction(context, params) {
      pushMessageAdd(params).then(json => {
        if (json.respCode === 100) {
        } else {
        }
      });
    },
    pushMessageListAction(context, params) {
      let vueObj = params.vueObj;
      delete params.vueObj;
      pushMessageList(params).then(json => {
        if (json.respCode === 100 && json.data !== undefined) {
          context.commit("messageListTotalMutation", json.total);
          context.commit("messageListMutations", json.data);
          if (json.data.length === 0 && vueObj.searchParamObj.page > 1) {
            vueObj.searchParamObj.page--;
            context.dispatch("pushMessageListAction", vueObj.searchParamObj);
          }
        } else {
          // Global.messageErr('获取列表失败');
        }
      });
    }
  },
  getters: {
    // 带全部的品牌下拉
    getProcessedMessageList: state => {
      let grocessedMessageList = [];

      state.messageList.forEach(element => {
        let messageObj = {};
        messageObj = {
          id: element.id,
          userId: element.userId,
          noticeType: element.noticeType,
          dataId: element.dataId,
          dataTypeId: element.dataTypeId,
          isDelete: element.isDelete,
          isRead: element.isRead,
          remarks: element.remarks,
          updateTime: element.updateTime,
          createTime: element.createTime
        };
        if (element.noticeType === 204){
          let notice = element.notice;
          let arg1position = notice.indexOf("arg1");
          let arg2position = notice.indexOf("！");
          messageObj.message1 = notice.substring(0, arg1position); //HI
          messageObj.message2 = notice.substring(arg1position+4, arg2position+1); //内容
          let userId1 = "";
          let userName1 = ""; //用户1的用户名
          let argArray = JSON.parse(element.argsJson);
          argArray.forEach(argEle => {
            if (argEle.argId === "arg1") {
              userId1 = argEle.data[0].dataId;
              messageObj.userId1 = userId1;
              userName1 = argEle.data[0].dataName
                ? argEle.data[0].dataName
                : `用户${argEle.data[0].dataId}`;
              messageObj.userName1 = userName1;
            }
          });
          grocessedMessageList.push(messageObj);
        }
        //游记被评论202 评论被点赞201
        if (element.noticeType === 202 || element.noticeType === 201) {
          let notice = element.notice;
          let arg1position = notice.indexOf("arg1");
          let arg2position = notice.indexOf("arg2");
          let arg3position = notice.indexOf("arg3");
          messageObj.message1 = notice.substring(0, arg1position); //HI
          messageObj.message2 = notice.substring(
            arg1position + 4,
            arg2position
          ); //站内观众
          messageObj.message3 = notice.substring(
            arg2position + 4,
            arg3position - 1
          ); //刚刚赞了你的评论：
          //评论点赞模板: HI，arg1，站内观众arg2刚刚赞了你的评论：“arg3”
          grocessedMessageList.push(messageObj);
          let argArray = JSON.parse(element.argsJson);
          let userId1 = ""; //用户1的用户id
          let userName1 = ""; //用户1的用户名
          let userId2 = ""; //用户2的用户id
          let userName2 = ""; //用户2的用户名
          let message4 = ""; //评论具体内容
          argArray.forEach(argEle => {
            if (argEle.argId === "arg1") {
              userId1 = argEle.data[0].dataId;
              messageObj.userId1 = userId1;
              userName1 = argEle.data[0].dataName
                ? argEle.data[0].dataName
                : `用户${argEle.data[0].dataId}`;
              messageObj.userName1 = userName1;
            }
            if (argEle.argId === "arg2") {
              userId2 = argEle.data[0].dataId;
              messageObj.userId2 = userId2;
              userName2 = argEle.data[0].dataName
                ? argEle.data[0].dataName
                : `用户${argEle.data[0].dataId}`;
              messageObj.userName2 = userName2;
            }
            if (argEle.argId === "arg3") {
              message4 = `“${argEle.data[0].dataName}”`;
              messageObj.message4 = message4;
              //游记被评论202 获取游记id
              if (element.noticeType === 202) {
                messageObj.message4Id = argEle.data[0].dataId;
              }
            }
          });
        }
        if (element.noticeType === 101) {
          //注册模板:HI，arg1，欢迎加入鹿驾，成为我们的第 5126 名鹿友！↵我们一起，看尽祖国山川，记录中华美景...
          let notice = element.notice;
          let arg1position = notice.indexOf("arg1");
          let exclamationPostion = notice.indexOf("！");
          messageObj.message1 = notice.substring(0, arg1position);
          messageObj.message2 = notice.substring(
            arg1position + 4,
            exclamationPostion + 1
          );
          messageObj.message3 = notice.substring(
            exclamationPostion + 1,
            notice.length
          );
          let userId1 = "";
          let userName1 = "";
          let argArray = JSON.parse(element.argsJson);
          argArray.forEach(argEle => {
            if (argEle.argId === "arg1") {
              userId1 = argEle.data[0].dataId;
              messageObj.userId1 = userId1;
              userName1 = argEle.data[0].dataName
                ? argEle.data[0].dataName
                : `用户${argEle.data[0].dataId}`;
              messageObj.userName1 = userName1;
            }
          });
          grocessedMessageList.push(messageObj);
        }
        //网站审核游记消息通过
        if (element.noticeType === 102) {
          messageObj.message1 = "HI,";
          messageObj.message2 = "，感谢你的无私分享，你提交的";
          messageObj.message3 = "已审核通过，它将使更多人的旅程更完美!";
          let noticeId = "";
          let noticeName = "";
          let argArray = JSON.parse(element.argsJson);
          argArray.forEach(argEle => {
            if (argEle.argId === "arg1") {
              messageObj.userId1 = argEle.data[0].dataId;
              messageObj.userName1 = argEle.data[0].dataName
                ? argEle.data[0].dataName
                : `用户${argEle.data[0].dataId}`;
            }
            if (argEle.argId === "arg2") {
              noticeId = argEle.data[0].dataId;
              messageObj.noticeId = noticeId;
              noticeName = argEle.data[0].dataName;
              messageObj.noticeName = `《${noticeName}》`;
            }
          });
          grocessedMessageList.push(messageObj);
        }
      });
      return grocessedMessageList;
    }
  }
};

export default MessageStore;
